import useTableColumns from './useTableColumns'
import useTabs from './useTabs'
import useGradesTableColumns from './useGradesTableColumns'
import useTestTakersHeaderFilters from './useTestTakersHeaderFilters'
import useClassesTableColumns from './useClassesTableColumns'
import useTestTakersTableColumns from './useTestTakersTableColumns'
import useGroupsTableColumns from './useGroupsTableColumns'
import useYearFilter from './useYearFilter'

export default { useGroupsTableColumns, useClassesTableColumns, useTestTakersTableColumns, useTableColumns, useGradesTableColumns, useTabs, useTestTakersHeaderFilters, useYearFilter }